import { useEffect, useRef } from 'react';
import './bannerSecondary.scss';
import IconPromise from 'components/widgets/IconPromise/IconPromise';

export interface IBannerSecondary {
  url?: any;
  title: string;
  text?: string;
  color?: string;
  iconId: number;
  numberOfItems?: number;
  onClick?: any;
  selected?: boolean;
  grid?: string;
  disabled?: boolean | undefined
}

export default function BannerSecondary({
  title,
  iconId,
  onClick,
  selected,
  numberOfItems = 0,
  grid,
  disabled
}: IBannerSecondary) {
  const containerRef = useRef<HTMLDivElement>(null); // Referencia al contenedor

  const ajustarFontSize = () => {
    const anchoContenedor = containerRef.current?.offsetWidth;
    if (containerRef.current) {
      const h3 = containerRef.current.querySelector('h3');
      if (h3 && anchoContenedor) {
        h3.style.fontSize = `calc(14px + ${anchoContenedor * 0.0006}px)`;
      }
    }
  };

  const handleClick = () => {
    onClick && onClick();
  };

  const handleItems = () => {
    if (grid) return grid;
    else if (numberOfItems === 4) return 'col-3--grid';
    else if (numberOfItems === 5) return 'col-5--grid';
    else if (numberOfItems === 6) return 'col-2--grid';
    return 'col-3';
  };

  useEffect(() => {
    window.addEventListener('resize', ajustarFontSize);
    ajustarFontSize(); // Ejecutar al cargar
    return () => window.removeEventListener('resize', ajustarFontSize); // Limpieza del event listener
  }, []);

  return (
    <div
      ref={containerRef}
      className={`${disabled ? 'bannerSecondary--disabled': `bannerSecondary${selected ? '--selected' : ''}`} ${handleItems()}`}
      onClick={()=> /* (!disabled) &&  */handleClick()}
    >
      <div className='bannerSecondary_icon'>
        <IconPromise idIcon={iconId} />
      </div>
      <div className='bannerSecondary_title'>
        <strong>{title}</strong>
      </div>
    </div>
  );
}
